import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

const BaseText = styled('span', {
  shouldForwardProp,
})(
  css({
    fontFamily: 'body',
  })
);

export default BaseText;
